import { styled } from '@mui/material/styles';
// const Root = styled("div")(({ theme }) => ({
//     padding: theme.spacing(1),
//     [theme.breakpoints.down("md")]: {
//       backgroundColor: red[500]
//     },
//     [theme.breakpoints.up("md")]: {
//       backgroundColor: blue[500]
//     },
//     [theme.breakpoints.up("lg")]: {
//       backgroundColor: green[500]
//     }
//   }));

export const MakeOfferLabel = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(1590)]: {
    fontSize: '18px',
  },
  [theme.breakpoints.down(1330)]: {
    fontSize: '24px',
  },
  [theme.breakpoints.down(600)]: {
    fontSize: '20px',
  },
}));
export const OfferLeftTime = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(1590)]: {
    fontSize: '14px',
  },
  [theme.breakpoints.down(1330)]: {
    fontSize: '16px',
  },
}));
export const MakeofferRectangle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up(1590)]: {
    width: '29.3rem',
  },
  [theme.breakpoints.down(1590)]: {
    width: '23rem',
  },
  [theme.breakpoints.down(1330)]: {
    width: '29.3rem',
  },
}));
// export const MakeofferSquareBox = styled("div")(({ theme }) => ({
//     [theme.breakpoints.down(1590)]: {
//       display:"flex",
//       flexDirection:"column",
//       spacing:"2"

//     },
//   }));

export const MakeOfferlabel = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(1590)]: {
    fontSize: '14px',
  },
  [theme.breakpoints.down(1330)]: {
    fontSize: '16px',
  },
}));

export const MakeOfferbtn = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(1590)]: {
    fontSize: '14px',
  },
  [theme.breakpoints.down(1330)]: {
    fontSize: '16px',
  },
}));
